import { types } from 'mobx-state-tree';
import { v4 as uuid } from 'uuid';

import { BaseDocument, partiallyUpdateModel } from '../definitions/Common';
import { QUOTE_STATUSES, Metadata } from '../definitions/InsCommon';
import Quote from './Quote';
import Application from './Application';
import Inquiry from './Inquiry';


const InsHomeDocument = BaseDocument
    .named('InsHomeDocument')
    .props({
        id: types.optional(types.identifier, () => uuid()),
        schemaVersion: 8,

        application: types.optional(Application, {}),

        // User selected quotes, we will also be 
        //  adding the quote ID of the selected quotes to 
        //  an inquiry event, but they are also stored here
        //  so the BE can add extra data and they are available
        //  for the dashboard
        quotes: types.array(Quote),

        // Need to support inquiries for simple home lead form 
        //  and mortgage cross sell. Since BaseDocument contains
        //  events we can work to move those places to use events and 
        //  eventually deprecate inquiries in the next version (V9)
        inquiries: types.array(Inquiry),

        metadata: types.optional(Metadata, {}),
    })
    .actions(self => ({
        // Currently used by ins-simple-home-wizard, 
        //  ideally this would be on Application instead since we don't
        //  want our root document to be modified
        update(value) {
            partiallyUpdateModel(self, value);
        },

        // See comment with inquiries, we'd like to deprecate this
        //  and use trackEvent instead
        inquire(inquiry) {
            self.inquiries.push(inquiry);
        },

        submitQuote(quote) {
            if (!quote || !quote?.id) {
                throw new Error(`[InsHomeDocument.submitQuote] Cannot submit quote inquiry without quote or quote id. Received quote: ${quote}`);
            }

            if (quote.status === QUOTE_STATUSES.SUBMITTED) {
                throw new Error(`[InsHomeDocument.submitQuote] Quote's status has already been submitted ${quote}`);
            }

            const existingQuote = self.quotes.find(storedQuote => storedQuote.id === quote.id);

            if (existingQuote) {
                existingQuote.setStatus(QUOTE_STATUSES.SUBMITTING);
                return;
            }

            self.quotes.push({
                ...quote,
                status: QUOTE_STATUSES.SUBMITTING,
            });
        },
        
        // This setter is used to set the application province state. The province
        // is used for routing and question determination. Setting the province
        // here will override the address field from its previous state to ensure
        // we aren't created an invalid address
        setApplicationProvince(province) {            
            self.application.property = {
                ...self.application.property,
                address: {
                    province,
                },
            };
        },
    }));

export default InsHomeDocument;
